import * as React from "react";
import Job from "./Job";

interface JobListProps {
  jobs: any[];
  zipjobs: any[];
  sort: string;
  records?: number;
  showHeader?: boolean;
}

export const JobList: React.FC<JobListProps> = ({ jobs, zipjobs, sort, showHeader = true }) => {
  const shouldShowZipJobs = sort === "newest" && zipjobs && zipjobs.length > 0;

  // Combine and sort jobs if salary sorting
  const jobsToRender = React.useMemo(() => {
    if (sort === "highest_salary" || sort === "lowest_salary") {
      const sortedJobs = [...jobs].sort((a, b) => {
        const salaryA = parseFloat(a.comp || 0);
        const salaryB = parseFloat(b.comp || 0);
        return sort === "highest_salary" ? salaryB - salaryA : salaryA - salaryB;
      });
      return sortedJobs;
    }
    return jobs;
  }, [jobs, sort]);

  return (
    <>
      {/* Header */}
      {showHeader && (
        <div style={{
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'linear-gradient(135deg, #085ec8 0%, #0a6fd9 50%, #085ec8 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Subtle texture overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,255,255,0.08) 0%, transparent 40%)',
            pointerEvents: 'none',
          }} />
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            position: 'relative',
            zIndex: 1,
          }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              background: 'rgba(255, 255, 255, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(4px)',
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
              </svg>
            </div>
            <h2 style={{
              margin: 0,
              fontSize: '1.125rem',
              fontWeight: 700,
              color: 'white',
              letterSpacing: '-0.01em',
            }}>
              Jobs
            </h2>
          </div>
        </div>
      )}

      {/* Job List */}
      <div style={{ background: 'white' }}>
        {shouldShowZipJobs && zipjobs.length > 0 && (
          <>
            {/* Featured Jobs Section */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.625rem',
              padding: '0.875rem 1.5rem',
              background: 'linear-gradient(135deg, #fef9e7 0%, #fef3c7 100%)',
              borderBottom: '1px solid #fde68a',
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              <span style={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: '#92400e',
                textTransform: 'uppercase',
                letterSpacing: '0.03em',
              }}>
                Featured Opportunities
              </span>
            </div>

            {zipjobs.map((job, index) => (
              <Job key={`zip-${job.id || index}`} job={job} isZipJob={true} />
            ))}

            {/* Divider */}
            <div style={{
              height: '8px',
              background: '#f1f5f9',
              borderTop: '1px solid #e2e8f0',
              borderBottom: '1px solid #e2e8f0',
            }} />
          </>
        )}

        {jobsToRender.map((job, index) => (
          <Job key={job.id || index} job={job} isZipJob={false} />
        ))}

        {/* Bottom padding */}
        <div style={{ height: '0.5rem' }} />
      </div>
    </>
  );
};

export default JobList;
